<!--
Componente per la gestione delle deadline

Parametri che si ricevono dalla vista dove viene richiamato il componente

    PARAMETRO                     TIPOLOGIA         REQUIRED      DEFAULT             DESCRIZIONE
    modal_id                      String            FALSE         gap_modal           ID con cui viene richiamato il modale

-->

<template>
  <div>
    <div
      aria-hidden="true"
      :aria-labelledby="this.modal_id"
      data-backdrop="static"
      data-keyboard="false"
      class="modal fade hide"
      :id="this.modal_id"
      role="dialog"
      style="max-width: 680px; width: 88%"
    >
      <div class="modal-header">
        <h3 class="title">
          {{ i18nJS.deadlines_planning }}
          <button @click="closeModal()" aria-hidden="true" class="close" data-dismiss="modal" type="button">
            <i class="fa-light fa-xmark"></i>
          </button>
        </h3>
        <div class="text-danger" v-if="this.error_msg">
          {{ this.error_msg }}
        </div>
      </div>
      <div class="modal-body" style="min-height: 400px">
        <div class="form-group">
          <div>
            <div class="control-group">
              <label for="descrizione" class="control-label">{{ i18nJS.description }}</label>
              <div class="controls">
                <input type="text" id="descrizione" class="form-control" :disabled="!this.editable" v-model="new_description" />
              </div>
            </div>
            <div class="control-group">
              <label class="control-label" for="notes">{{ i18nJS.notes }}</label>
              <div class="controls">
                <textarea id="notes" class="form-control span12" :disabled="!this.editable" v-model="new_notes"></textarea>
              </div>
            </div>
            <div class="control-group">
              <label class="control-label">{{ i18nJS.forms.guest_activity_plans.data['datein'] }}</label>
              <div class="controls">
                <datepicker :disabled="!this.editable" :value="new_from" @input="(val) => (new_from = val)" id="from" />
              </div>
            </div>
            <div class="control-group">
              <label class="control-label">{{ i18nJS.forms.guest_activity_plans.data['dateout'] }}</label>
              <div class="controls">
                <datepicker :disabled="!this.editable" :value="new_to" @input="(val) => (new_to = val)" id="to" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.deadline_id === null || this.editable" class="modal-footer">
        <template>
          <button @click="createDeadline()" class="btn btn-primary" :disabled="false">
            {{ i18nJS.command['save'] }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import apiConnector from '@/epersonam/apiConnector';
import datepicker from '../datepicker';

export default {
  name: 'deadlineForm',
  props: {
    deadline_id: { type: Number, default: null },
    editable: { type: Boolean, default: false },
    modal_id: { type: String, default: 'deadline_modal' },
    business_unit_id: { type: Number, required: true },
    guest_name: { type: String, default: null },
    description: { type: String, required: true },
    notes: { type: String, default: 'Scadenza creata il: ' },

    from: { type: String, required: true },
    to: { type: String, required: true },

    resource_plan_id: { type: Number, required: true },
    resource_plan_type: { type: String, required: true },

    connected_id: { type: Number, required: true },
    connected_type: { type: String, required: true },
  },
  components: {
    datepicker,
  },
  data() {
    return {
      base_url: window.config.ePersonamService.ePersonamHost + '/' + window.locale,
      error_msg: null,
      new_from: this.dateFormatter(this.from),
      new_to: this.dateFormatter(this.to),
      new_description: this.guest_name ? `${this.description}, per: ${this.guest_name}` : `${this.description}`,
      new_notes: this.notes,
    };
  },
  watch: {},
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  mounted() {},
  methods: {
    dateFormatter(date) {
      return new Date(date).toLocaleDateString('it-IT', { month: '2-digit', day: '2-digit', year: 'numeric' });
    },
    timeFormatter(time) {
      return new Date(time).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
    },
    openModal() {
      $('#' + this.modal_id).modal('show');
    },
    closeModal() {
      $('#' + this.modal_id).modal('hide');
    },
    buildDeadline() {
      return {
        resource_plan_type: this.resource_plan_type,
        resource_plan_id: this.resource_plan_id,

        connected_id: this.connected_id,
        connected_type: this.connected_type,

        from_date: this.new_from,
        repeats_end_on: this.new_to,

        business_unit_id: this.business_unit_id,
        description: this.new_description,
        notes: this.new_notes,
      };
    },
    createDeadline() {
      Loader.show();

      let params = {
        deadlines_plan: this.buildDeadline(),
      };

      apiConnector()
        .post(this.base_url + '/deadlines_plans.json', params)
        .then((res) => {
          Loader.hide();
          this.closeModal();
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            if (err.response.data.base && err.response.data.base[0]) {
              this.error_msg = err.response.data.base[0];
            }
            if (err.response.data.errore) {
              this.error_msg = err.response.data.errore;
            }
          }
          Loader.hide();
          console.log('Could not set initial value', err);
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
